export const MAX_EVENT_LOGO_BYTES = 2 * 1024 * 1024;

export const getLogoFileError = file => {
  if (!['image/jpeg', 'image/png'].includes(file.type)) return 'The logo must be a JPG or PNG image';
  if (file.size > MAX_EVENT_LOGO_BYTES) return 'The logo cannot exceed 2 MB';
  return null;
};
